<template>
  <div :class="['content', { 'content-en': !iscn }]" ref="content">
    <div class="wrap">
      <div v-if="iscn" class="title-info2 title-1">走向世界的绿色转转</div>
      <div v-else class="title-info2 title-1">
        Our green movement going Global
      </div>
      <div class="world">
        <div :class="['world-item-wrap', {'world-item-wrap-en': !iscn}]">
          <img v-if="iscn" src="../assets/model-info2-1.png" class="world-item-bg" alt="">
          <img v-else src="../assets/model-info2-1-en.png" class="world-item-bg-en" alt="">
          <div v-if="iscn" class="world-item-title">2023</div>
          <div v-else class="world-item-title">In 2023</div>
          <div v-if="iscn" class="world-item-desc">转转受邀出席第28届联合国气候变化大会（COP28）,成为中国循环经济领域首个参会企业。</div>
          <div v-else class="world-item-desc">ZhuanZhuan was invited to attend the 28th United Nations Climate Change Conference (COP28), becoming the first Chinese company in the field of circular economy to participate.</div>
        </div>
        <div :class="['world-item-wrap', {'world-item-wrap-en': !iscn}]">
          <img v-if="iscn" src="../assets/model-info2-2.png" class="world-item-bg" alt="">
          <img v-else src="../assets/model-info2-2-en.png" class="world-item-bg-en" alt="">
          <div v-if="iscn" class="world-item-title">2024</div>
          <div v-else class="world-item-title">In 2024</div>
          <div v-if="iscn" class="world-item-desc">转转再一次登上联合国（COP29）的舞台，让二手iPad在会场中大放异彩，也与国际社会分享了转转的官方验和“千城计划”，还成功入选了《2024“美丽中国，我是行动者”企业气候行动案例集》。</div>
          <div v-else class="world-item-desc">ZhuanZhuan took the stage at the United Nations COP29 once again, showcasing second-hand iPads at the event. We also shared our official verification process and the "Thousand Cities Program" with the international community, while successfully being included in the "2024 'Beautiful China, I Am an Actor' Corporate Climate Action Casebook."</div>
        </div>
      </div>
      <div v-if="iscn" class="title-info2 title-2">碳减排，转转可是学术派！</div>
      <div v-else class="title-info2 title-2">
        Our professional approach to<br/>
        carbon mitigation
      </div>
      <div class="certification">
        <img v-if="iscn" src="../assets/model-info2-3.png" class="certification-item" alt="">
        <img v-else src="../assets/model-info2-3-en.png" class="certification-item" alt="">
        <img v-if="iscn" src="../assets/model-info2-4.png" class="certification-item" alt="">
        <img v-else src="../assets/model-info2-4-en.png" class="certification-item" alt="">
        <img v-if="iscn" src="../assets/model-info2-5.png" class="certification-item" alt="">
        <img v-else src="../assets/model-info2-5-en.png" class="certification-item" alt="">
        <img v-if="iscn" src="../assets/model-info2-6.png" class="certification-item" alt="">
        <img v-else src="../assets/model-info2-6-en.png" class="certification-item" alt="">
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Rellax from 'rellax'

export default Vue.extend({
  name: 'earth-waring-area',
  computed: {
    iscn: function() {
      return this.$store.state.lang === 'zh-cn'
    }
  },
  mounted() {
    this.initAnimation()

    new Rellax('.title-1', {
      speed: -0.1,
      center: true,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    })
    new Rellax('.world', {
      speed: 1,
      center: true,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    })
    new Rellax('.title-2', {
      speed: -0.1,
      center: true,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    })
    new Rellax('.certification', {
      speed: 1,
      center: true,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    })
  },
  methods: {
    initAnimation() {
      // 监听滚动事件，当元素earthPic进入视口时，给元素增加动画类
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            // 冰川图部分
            if (entry.target.classList.contains('title-1') && entry.isIntersecting) {
              setTimeout(() => {
                document.querySelector('.title-1')?.classList?.add('fade-in')
              }, 70)
            }
            if (entry.target.classList.contains('world') && entry.isIntersecting) {
              setTimeout(() => {
                document.querySelectorAll('.world-item-wrap')?.forEach((item) => {
                  item.classList?.add('zoom-in')
                })
              }, 70)
            }
            if (entry.target.classList.contains('title-2') && entry.isIntersecting) {
              setTimeout(() => {
                document.querySelector('.title-2')?.classList?.add('fade-in')
              }, 70)
            }
            if (entry.target.classList.contains('certification') && entry.isIntersecting) {
              setTimeout(() => {
                document.querySelectorAll('.certification-item')?.forEach((item) => {
                  item.classList?.add('zoom-in-fast')
                })
              }, 70)
            }
          })
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 0.2
        }
      )
      observer.observe(document.querySelector('.title-1') as Element)
      observer.observe(document.querySelector('.world') as Element)
      observer.observe(document.querySelector('.title-2') as Element)
      observer.observe(document.querySelector('.certification') as Element)
    }
  }
})
</script>

<style scoped lang="scss">
@keyframes zoomIn {
  from {
    transform: scale3d(0.7, 0.7, 0.7);
    opacity: 0;
  }

  50% {
    opacity: 0.3;
  }

  to {
    transform: scale3d(1, 1, 1);
    opacity: 1;
  }
}

@keyframes zoomInPic {
  from {
    transform: scale3d(0.9, 0.9, 0.9);
    opacity: 0;
  }

  to {
    transform: scale3d(1, 1, 1);
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(200px);
  }

  to {
    transform: translateY(0);
  }
}

.fade-in {
  animation: fadeIn 1s 0s forwards;
}

.zoom-in {
  animation: zoomIn 1s 0s forwards;
  animation-timing-function: linear;
}

.zoom-in-fast {
  animation: zoomIn 800ms 0s forwards;
  animation-timing-function: linear;
}

.zoom-in-pic {
  animation: zoomInPic 1s 0s forwards;
}

.earth-banner-up {
  animation: slideUp 0.8s 0s forwards;
}

.content {
  position: relative;
  z-index: 3;
  width: 1920px;
  min-width: 1280px;
  max-width: 1920px;
  height: 2265px;
  margin: 0 auto;
  background: #fff;
  &.content-en {
    height: 2500px;
  }
}
.wrap {
  width: 1597px;
  height: 1955px;
  margin: 0 auto;
  .title-info2 {
    font-family: alibaba;
    font-weight: 1000;
    font-size: 80px;
    color: #111111;
    line-height: 80px;
    text-align: center;
    padding: 220px 0 120px;
    opacity: 0;
  }
}
.world {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .world-item-wrap {
    flex: 0 0 762px;
    width: 762px;
    height: 822px;
    position: relative;
    text-align: left;
    opacity: 0;
    &.world-item-wrap-en {
      height: 1002px;
    }
  }
  .world-item-bg {
    position: absolute;
    width: 762px;
    height: 822px;
    left: 0;
    top: 0;
  }
  .world-item-bg-en {
    position: absolute;
    width: 762px;
    height: 1002px;
    left: 0;
    top: 0;
  }
  .world-item-title {
    font-family: alibaba;
    font-weight: 1000;
    font-size: 40px;
    color: #000000;
    line-height: 40px;
    text-align: left;
    padding-top: 520px;
    width: 670px;
    margin: 0 auto;
    position: relative;
    z-index: 2;
  }
  .world-item-desc {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 28px;
    color: #000000;
    line-height: 48px;
    text-align: left;
    width: 680px;
    padding-top: 22px;
    margin: 0 auto;
    position: relative;
    z-index: 2;
    word-break: break-word;
  }
}
.certification {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .certification-item {
    width: 360px;
    height: 432px;
    opacity: 0;
  }
}
</style>
